export default function PHP_fputcsv() {
  return (
    <div>
      <h1>PHP_fputcsv</h1>
    </div>
  );
}
